import { ReactElement } from "react";
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { ExitToApp, Home } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSetRecoilState } from "recoil";
import { configState, DEFAULT_CONFIG_STATE } from "base/store/config";
import { useQueryClient } from "@tanstack/react-query";
import { signOut } from "base/utils/auth";

interface Props {
  onClickOpenProfileGW: () => void;
}

type ListItemType = {
  text: string;
  icon: ReactElement;
  onClick: () => void;
};

const UserPopupContent = ({ onClickOpenProfileGW }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const setConfigState = useSetRecoilState(configState);

  const onLogout = async () => {
    // Clear local state even if the request fails, so a network error can't trap the user in a logged-in UI.
    try {
      await signOut();
    } catch (e) {
      // ignore — fall through to local cleanup
    }
    queryClient.removeQueries();
    setConfigState(DEFAULT_CONFIG_STATE);
    navigate("/login");
  };

  const LIST: ListItemType[] = [
    {
      text: t("menu_groupware"),
      icon: <Home />,
      onClick: onClickOpenProfileGW,
    },
    {
      text: t("menu_signout"),
      icon: <ExitToApp />,
      onClick: onLogout,
    },
  ];

  return (
    <List disablePadding>
      {LIST.map((item) => (
        <ListItem key={item.text} disablePadding>
          <ListItemButton onClick={item.onClick}>
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.text} />
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );
};

export default UserPopupContent;
